"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubjectSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
const language_1 = require("./language");
const subject_level_1 = require("./subject-level");
const image_file_1 = require("./image-file");
const content_visit_info_1 = require("./content-visit-info");
const subject_stats_1 = require("./subject-stats");
exports.SubjectSchema = zod_1.z.object({
  id: zod_1.z.number(),
  code: zod_1.z.string(),
  title: zod_1.z.string(),
  category_id: zod_1.z.nativeEnum(lingo2_models_1.SubjectCategoryEnum),
  language_id: zod_1.z.number(),
  language: language_1.LanguageSchema.optional(),
  levels_category_id: zod_1.z.number().optional(),
  levels: zod_1.z.array(subject_level_1.SubjectLevelSchema).optional(),
  banner: zod_1.z.record(image_file_1.ImageFileSchema).optional(),
  cover: zod_1.z.record(image_file_1.ImageFileSchema).optional(),
  cover_id: zod_1.z.string().optional(),
  visit_info: content_visit_info_1.ContentVisitInfoSchema.partial().optional(),
  stats: subject_stats_1.SubjectStatsSchema.partial().optional()
});
